export default __webpack_public_path__ + "static/media/no-access.f1ec1f63.png";